import NotificationEditor from "./NotificationEditor";

export default function NotificationCreate() {
  return <NotificationEditor mode="create" />;
}